import { useState } from 'react';

import lang from '../../lib/language';

import { useIsMobile } from '../../hooks';
import BaseModal from '../../shared_components/BaseModal/BaseModal';
import Button from '../../shared_components/Button/Button';
import { MobileDrawer } from '../index';

import styles from './NotEnoughBuyingPower.module.scss';

type Props = {
  closeModal: () => void;
};

const NotEnoughBuyingPower = ({ closeModal }: Props) => {
  const { isMobile } = useIsMobile();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const handleClose = () => setIsOpen(false);

  const renderContent = () => (
    <>
      <div className={styles.text}>{lang.commonTradingNotEnoughBuyingPowerDescription()}</div>
      <div className={styles.buttonsWrapper}>
        <Button
          fullWidth
          biggerFontSize
          onClick={handleClose}
        >
          {lang.commonOkay()}
        </Button>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <MobileDrawer
        isOpen={isOpen}
        title={lang.commonTradingNotEnoughBuyingPowerTitle()}
        onClose={closeModal}
      >
        {renderContent()}
      </MobileDrawer>
    );
  }

  return (
    <BaseModal isOpen={isOpen} toggle={closeModal}>
      <div className={styles.title}>{lang.commonTradingNotEnoughBuyingPowerTitle()}</div>
      {renderContent()}
    </BaseModal>
  );
};

export default NotEnoughBuyingPower;
